import { render, staticRenderFns } from "./DownlineRepAddressAdd.vue?vue&type=template&id=6af1e13b&"
import script from "./DownlineRepAddressAdd.vue?vue&type=script&lang=js&"
export * from "./DownlineRepAddressAdd.vue?vue&type=script&lang=js&"
import style0 from "./DownlineRepAddressAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports